/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 * Personal data delete modal windows reducer.
 *
 * @author Dmitriy Kvon
 * @version 1.17.0
 * @since 1.17.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { initialPersonalDataDeleteState, PERSONAL_DATA_DELETE_SUCCESS } from './personalDataDeleteConstants';
import { IPersonalDataDeleteActions } from './personalDataDeleteTypes';


export interface IPersonalDataDeleteReducer {
    orderId: string;
}

const personalDataDeleteReducer: Reducer<IPersonalDataDeleteReducer, IPersonalDataDeleteActions> =
    (state = initialPersonalDataDeleteState, action: IPersonalDataDeleteActions) =>
        produce(state, draft => {
            switch (action.type) {
                case PERSONAL_DATA_DELETE_SUCCESS:
                    draft.orderId = action.payload.orderId;
                    break;
            }
        });


export default personalDataDeleteReducer;
